import { PropsWithChildren, ReactNode, useState } from 'react';

import { Popover } from './Popover';

export function Tooltip(props: PropsWithChildren) {
	return <>{props.children}</>;
}

export function TooltipTarget(props: PropsWithChildren<{ contents: ReactNode }>) {
	const [visible, setVisible] = useState(false);

	return (
		<Popover.Target contents={<Tooltip>{props.contents}</Tooltip>} visible={visible}>
			<div
				onMouseMove={
					visible
						? undefined
						: (event) => {
								setVisible(true);

								const bounds = event.currentTarget.getBoundingClientRect();

								const onMouseMove = function onMouseMove(event: MouseEvent) {
									if (
										event.clientX < bounds.left ||
										event.clientX > bounds.right ||
										event.clientY < bounds.top ||
										event.clientY > bounds.bottom
									) {
										setVisible(false);
										window.removeEventListener('mousemove', onMouseMove);
									}
								};

								window.addEventListener('mousemove', onMouseMove);
						  }
				}
			>
				{props.children}
			</div>
		</Popover.Target>
	);
}

Tooltip.Target = TooltipTarget;
